import { LegacyOnlineContactDetailsStorageManager } from "./LegacyOnlineContactDetailsStorageManger";
export const ONLINE_CONTACT_DETAILS_KEY = "client_contactDetails";
export class OnlineContactDetailsStorageManager {
    store(contactDetails) {
        const contactDetailsDataString = JSON.stringify(contactDetails);
        localStorage.setItem(ONLINE_CONTACT_DETAILS_KEY, contactDetailsDataString);
    }
    restore() {
        const contactDetailsDataString = localStorage.getItem(ONLINE_CONTACT_DETAILS_KEY);
        if (contactDetailsDataString === null) {
            return new LegacyOnlineContactDetailsStorageManager().restore();
        }
        return JSON.parse(contactDetailsDataString);
    }
    erase() {
        localStorage.removeItem(ONLINE_CONTACT_DETAILS_KEY);
    }
}
